module.exports = __webpack_public_path__ + "img/hic-breast-cancer-female.a7a41b62.png";